import { render, staticRenderFns } from "./ConfirmAlterationRuleModal.vue?vue&type=template&id=5a7609a4&"
import script from "./ConfirmAlterationRuleModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmAlterationRuleModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAlterationRuleModal.vue?vue&type=style&index=0&id=5a7609a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports